<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12" @click="beforeLeave">
        <v-icon class="body-bold-smaller brand-60-base--text" size="12"
          >mdi-arrow-left</v-icon
        >
        <a type="primary" class="body-bold-smaller brand-60-base--text"
          >{{ $t('message.actions.return') }}
        </a>
      </v-col>
    </v-row>
    <div class="grid__control">
      <PlayerTabsSubtitle></PlayerTabsSubtitle>

      <!-- settings::controls -->
      <portal to="subtitle-tab">
        <v-card v-scroll.self="onScroll" flat width="100%">
          <template v-if="loadings.fetching">
            <v-skeleton-loader
              type="image"
              height="48px"
              style="margin-top: 1px"
            ></v-skeleton-loader>
            <v-skeleton-loader
              type="image"
              height="48px"
              style="margin-top: 1px"
            ></v-skeleton-loader>
            <v-skeleton-loader
              type="image"
              height="48px"
              style="margin-top: 1px"
            ></v-skeleton-loader>
            <v-skeleton-loader
              type="image"
              height="34px"
              width="148px"
              class="mt-4"
            ></v-skeleton-loader>
          </template>
          <template v-else>
            <template v-if="allSubtitles.length">
              <div class="d-flex flex-column">
                <h3 class="body-bold-base neutral-20-dark--text my-2">
                  {{ $i18next.t('message.ai.subtitles.availableSubs') }}
                </h3>
                <span class="body-regular-smaller neutral-40-light--text">{{
                  $i18next.t('message.ai.subtitles.readyToUse')
                }}</span>
              </div>
              <v-row no-gutters>
                <div
                  v-for="(subtitle, i) in allSubtitles"
                  :key="`${i}${updateKey}__sub`"
                  class="f-width py-2 d-flex align-center justify-space-between"
                >
                  <!-- <template v-if="subtitle.hasOwnProperty('metadata')">
                    <div class="d-flex align-center" style="gap: 16px">
                      <FlagCards
                        :items="[
                          getCountryCodeBySrcLang(
                            subtitle.metadata.to_lang ||
                              subtitle.metadata.from_lang
                          ),
                        ]"
                      />
                      <span
                        class="body-regular-small neutral-20-dark--text"
                        :class="{
                          'hidden-sub': subtitle.metadata.hidden,
                        }"
                      >
                        {{
                          getLangLabelBySrclang(
                            subtitle.metadata.to_lang ||
                              subtitle.metadata.from_lang
                          )
                        }}
                      </span>
                    </div>
                    <div
                      class="d-flex align-center"
                      v-if="(subtitles[i] || {}).hidden"
                    >
                      <div>
                        <v-tag type="neutral" class="ml-1">{{
                          $i18next.t('message.ai.dubbings.hidden')
                        }}</v-tag>
                      </div>
                    </div>
                    <div
                      class="d-flex align-center"
                      v-if="
                        subtitle.status === 'QUEUE' ||
                        subtitle.status === 'RUNNING'
                      "
                    >
                      <div
                        class="mr-1 d-flex align-center"
                        style="position: relative"
                      >
                        <v-progress-circular
                          :size="16"
                          :width="3"
                          color="brand"
                          style="top: 0; position: absolute"
                        ></v-progress-circular>

                        <v-progress-circular
                          :size="16"
                          :width="3"
                          color="brand"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                      <span
                        :class="{
                          'neutral--text text--lighten-1': !$vuetify.theme.dark,
                        }"
                        >{{
                          $i18next.t(
                            'message.ai.subtitles.modal.auto.final_screen.title'
                          )
                        }}
                      </span>
                    </div>
                    <template >
                      <div class="d-flex align-center">
                        <span
                          class="mr-4 red--text"
                          v-if="
                            subtitle.status === 'ERROR' &&
                            !subtitle.metadata.language_not_supported
                          "
                          >{{ $i18next.t('message.ai.dubbings.error') }}</span
                        >
                        <template
                          v-if="
                            subtitle.status === 'ERROR' &&
                            subtitle.metadata.language_not_supported
                          "
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                class="mr-4 warning--text"
                                v-bind="attrs"
                                v-on="{ ...on, ...$listeners }"
                                >{{
                                  $i18next.t('message.ai.noLanguageSupport')
                                }}</span
                              >
                            </template>
                            {{
                              $i18next.t(
                                'message.ai.skippedWarningNotSupported'
                              )
                            }}
                          </v-tooltip>
                        </template>
                        <template v-else-if="subtitle.status === 'SKIPPED'">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="{ ...on, ...$listeners }"
                                class="mr-4 warning--text"
                              >
                                {{ $i18next.t('message.ai.skipped') }}</span
                              >
                            </template>
                            <span>
                              {{ $i18next.t('message.ai.skippedWarning') }}:
                              {{ getBlockingItem(subtitle) }}</span
                            >
                          </v-tooltip>
                        </template>
                        <v-icon
                          color="red"
                          size="24px"
                          @click="handleConfirmSubtitleDelete(subtitle)"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                    </template>
                  </template> -->
                  <template>
                    <div class="d-flex align-center pointer" style="gap: 16px">
                      <img
                        style="width: 16px; height: 16px"
                        :src="
                          flagMap[
                            getCountryCodeBySrcLang(
                              (subtitle || {}).srclang ||
                                (subtitle.metadata || {}).to_lang ||
                                (subtitle.metadata || {}).from_lang
                            )
                          ]
                        "
                      />
                      <span
                        v-if="lowerCase(subtitle.label) !== 'auto'"
                        class="body-regular-small neutral-20-dark--text"
                        :class="{
                          'hidden-sub': (subtitles[i] || {}).hidden,
                        }"
                      >
                        {{
                          getLangLabelBySrclang(
                            (subtitle || {}).srclang ||
                              (subtitle.metadata || {}).to_lang ||
                              (subtitle.metadata || {}).from_lang
                          )
                        }}
                      </span>
                      <span
                        v-else
                        class="font-weight-medium pointer text-subtitle-2 text-subtitle-2__standardized"
                        :class="{ 'brand--text': !$vuetify.theme.dark }"
                      >
                        {{ $t('message.ai.detectedLang') }}
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 16px">
                      <div
                        class="d-flex align-center"
                        v-if="
                          subtitle.status === 'QUEUE' ||
                          subtitle.status === 'RUNNING'
                        "
                      >
                        <div
                          class="mr-1 d-flex align-center"
                          style="position: relative"
                        >
                          <v-progress-circular
                            :size="16"
                            :width="3"
                            color="brand"
                            style="top: 0; position: absolute"
                          ></v-progress-circular>

                          <v-progress-circular
                            :size="16"
                            :width="3"
                            color="brand"
                            indeterminate
                          ></v-progress-circular>
                        </div>
                        <div>
                          <v-tooltip bottom persistent :close-delay="5000">
                            <template v-slot:activator="{ on, attrs }">
                              <v-tag
                                v-bind="attrs"
                                v-on="on"
                                type="default"
                                class="ml-1"
                                >{{
                                  $i18next.t(
                                    'message.ai.subtitles.modal.auto.final_screen.title'
                                  )
                                }}</v-tag
                              >
                            </template>
                            <span>{{
                              $i18next.t('message.ai.subtitles.tooltipWait')
                            }}</span>
                          </v-tooltip>
                        </div>
                      </div>

                      <div
                        class="d-flex align-center"
                        v-if="
                          ((subtitles[i] || {}).srclang == defaultSubtitle ||
                            ((subtitles[i] || {}).srclang == 'pt-BR' &&
                              defaultSubtitle == 'pt')) &&
                          subtitle.status !== 'ERROR' &&
                          subtitle.status !== 'FAILED' &&
                          subtitle.status !== 'QUEUE' &&
                          subtitle.status !== 'RUNNING' &&
                          defaultSubtitle
                        "
                      >
                        <div>
                          <v-tag type="default" class="ml-1">{{
                            $i18next.t('message.ai.subtitles.default')
                          }}</v-tag>
                        </div>
                      </div>
                      <div
                        class="d-flex align-center"
                        v-if="(subtitles[i] || {}).hidden"
                      >
                        <div>
                          <v-tag type="neutral" class="ml-1">{{
                            $i18next.t('message.ai.dubbings.hidden')
                          }}</v-tag>
                        </div>
                      </div>
                      <div
                        class="d-flex align-center"
                        v-if="
                          subtitle.status === 'ERROR' ||
                          subtitle.status === 'FAILED' ||
                          subtitle.status === 'CONVERTED'
                        "
                      >
                        <span
                          v-if="
                            subtitle.status === 'ERROR' ||
                            subtitle.status === 'FAILED'
                          "
                        >
                          <v-tooltip bottom persistent :close-delay="500">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                v-bind="attrs"
                                v-on="{
                                  ...on,
                                  mouseenter: (e) => {
                                    tooltipVisible = true
                                    on.mouseenter && on.mouseenter(e)
                                  },
                                }"
                              >
                                <v-tag type="error" class="ml-1">{{
                                  $i18next.t('message.ai.dubbings.error')
                                }}</v-tag>
                              </div>
                            </template>
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                pointer-events: all !important;
                                z-index: 9999;
                              "
                            >
                              <span style="white-space: pre-line">{{
                                $t('message.ai.dubbings.tooltipError.text')
                              }}</span>
                              <base-btn
                                type="neutral"
                                size="xsmall"
                                @click.stop="redirectLink"
                              >
                                <a
                                  type="secondary"
                                  target="_blank"
                                  :href="
                                    $t('message.ai.dubbings.tooltipError.href')
                                  "
                                  >{{ $t('message.embedModal.knowMore') }}
                                  <v-icon size="16" class="ml-1"
                                    >mdi-open-in-new</v-icon
                                  >
                                </a>
                              </base-btn>
                            </div>
                          </v-tooltip>
                        </span>
                      </div>
                      <!-- <div
                        class="d-flex align-center"
                        v-if="checkAllSubtitlesAreOk()"
                      >
                        <span>
                          <template>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  class="mr-4 warning--text"
                                  v-bind="attrs"
                                  v-on="{ ...on, ...$listeners }"
                                  >{{
                                    $i18next.t('message.ai.noLanguageSupport')
                                  }}</span
                                >
                              </template>
                              {{
                                $i18next.t(
                                  'message.ai.skippedWarningNotSupported'
                                )
                              }}
                            </v-tooltip>
                          </template>
                        </span>
                        <v-icon
                          color="red"
                          size="24px"
                          @click="handleConfirmSubtitleDelete(subtitle)"
                        >
                          mdi-delete
                        </v-icon>
                      </div> -->
                      <div
                        class="d-flex align-center"
                        v-if="
                          subtitle.status !== 'QUEUE' &&
                          subtitle.status !== 'RUNNING' &&
                          subtitle.status !== 'ERROR' &&
                          subtitle.status !== 'FAILED' &&
                          subtitle.status !== 'SKIPPED'
                        "
                        style="gap: 16px"
                      >
                        <v-tooltip v-if="!isMobileBreakpoint" bottom left>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <base-btn
                                type="neutral"
                                class="neutral-40-light--text --subtitles"
                                :disabled="subtitle.status"
                                @click="handleOpenSubtitleContent(subtitles[i])"
                              >
                                <div class="d-flex align-center">
                                  <v-icon
                                    class="neutral-40-light--text"
                                    size="16px"
                                    >panda-edit</v-icon
                                  >
                                </div>
                              </base-btn>
                            </div>
                          </template>
                          <span>{{ $t('message.actions.edit') }}</span>
                        </v-tooltip>
                        <v-menu min-width="188px" offset-y left>
                          <template v-slot:activator="{ on, attrs }">
                            <base-btn
                              type="neutral"
                              v-bind="attrs"
                              v-on="on"
                              class="neutral-40-light--text --subtitles"
                            >
                              <v-icon size="16px" class="neutral-40-light--text"
                                >panda-menu-action</v-icon
                              >
                            </base-btn>
                          </template>
                          <v-list dense>
                            <v-list-item
                              v-if="
                                defaultSubtitle !== (subtitles[i] || {}).srclang
                              "
                              @click="handleSetSubtitleAsHidden(subtitles[i])"
                            >
                              <v-list-item-title>
                                <span class="body-regular-smaller">{{
                                  (subtitles[i] || {}).hidden
                                    ? $i18next.t(
                                        'message.ai.subtitles.buttons.show'
                                      )
                                    : $i18next.t(
                                        'message.ai.subtitles.buttons.hidden'
                                      )
                                }}</span>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="!(subtitles[i] || {}).hidden"
                              @click="handleUpdateDefaultSubtitle(subtitles[i])"
                            >
                              <v-list-item-title>
                                <span class="body-regular-smaller">
                                  {{
                                    defaultSubtitle !==
                                    (subtitles[i] || {}).srclang
                                      ? $i18next.t(
                                          'message.ai.subtitles.buttons.default'
                                        )
                                      : $i18next.t(
                                          'message.ai.subtitles.buttons.removeDefault'
                                        )
                                  }}</span
                                >
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="handleDownloadSubtitle(subtitles[i])"
                            >
                              <v-list-item-title>
                                <span class="body-regular-smaller">{{
                                  $t('message.ai.subtitles.buttons.download')
                                }}</span>
                              </v-list-item-title>
                            </v-list-item>

                            <v-list-item
                              @click="handleConfirmSubtitleDelete(subtitle)"
                            >
                              <v-list-item-title>
                                <span class="body-regular-smaller red--text">{{
                                  $t('message.ai.subtitles.buttons.remove')
                                }}</span>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <template v-if="subtitle.status === 'SKIPPED'">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="{ ...on, ...$listeners }"
                              class="mr-4 warning--text"
                            >
                              {{ $i18next.t('message.ai.skipped') }}</span
                            >
                          </template>
                          <span>
                            {{ $i18next.t('message.ai.skippedWarning') }}:
                            {{ getBlockingItem(subtitle) }}</span
                          >
                        </v-tooltip>
                      </template>
                      <v-tooltip
                        v-if="
                          subtitle.status == 'ERROR' ||
                          subtitle.status == 'FAILED' ||
                          subtitle.status === 'SKIPPED'
                        "
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <base-btn
                            :disabled="loading"
                            type="neutral"
                            class="panda-icons --subtitles"
                            @click="handleConfirmSubtitleDelete(subtitle)"
                          >
                            <img
                              style="display: flex"
                              v-bind="attrs"
                              v-on="on"
                              :src="
                                $vuetify.theme.dark
                                  ? require('@/assets/remove-dark.svg')
                                  : require('@/assets/remove.svg')
                              "
                              fill-class-name="fill-color"
                              fill="var(--v-brand-lighten1)"
                              width="16px"
                            />
                          </base-btn>
                        </template>
                        <span>{{ $t('message.pages.video.delete') }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </div>
              </v-row>
              <base-btn
                type="secondary"
                class="mt-2"
                size="small"
                @click="handleTriggerSubtitleSelect"
                ><v-icon>mdi-plus</v-icon>
                {{ $t('message.pages.videoEditModal.addSubtitle') }}</base-btn
              >
            </template>
            <template v-else>
              <div class="d-flex flex-column">
                <span class="body-bold-base neutral-20-dark--text">
                  {{ $i18next.t('message.ai.subtitles.availableSubs') }}</span
                >
                <span class="body-regular-smaller neutral-40-light--text">{{
                  $t('message.ai.subtitles.notCreatedSubs')
                }}</span>
              </div>
              <base-btn
                type="secondary"
                class="mt-2"
                size="small"
                @click="handleTriggerSubtitleSelect"
                ><v-icon>mdi-plus</v-icon>
                {{ $t('message.pages.videoEditModal.addSubtitle') }}</base-btn
              >
            </template>
            <v-card v-if="errors.subtitleRemove" class="mt-1" flat width="100%">
              <span class="red--text caption align-text">
                <v-icon color="red" size="18" class="pb-1 pr-1">
                  mdi-alert-circle
                </v-icon>
                {{ errors.unknownErrorsMsg
                }}<template v-if="errors.unknownErrorsCode">
                  Code:

                  {{ errors.unknownErrorsCode }}</template
                >
              </span>
            </v-card>
            <v-divider class="my-8"></v-divider>
            <template v-if="unusedSubLangCodesAi.length">
              <v-row no-gutters>
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex flex-column">
                    <span class="body-bold-base neutral-20-dark--text">{{
                      $i18next.t('message.ai.dubbings.goBeyondIa')
                    }}</span>
                    <span class="body-regular-smaller neutral-40-light--text">{{
                      $i18next.t('message.ai.dubbings.createWithIa')
                    }}</span>
                  </div>
                </div>
              </v-row>
              <v-row no-gutters>
                <v-col
                  v-for="(sub, index) in unusedSubLangCodesAi.slice(0, 6)"
                  :key="`${index}__sub`"
                  style="display: flex; justify-content: space-between"
                  cols="12"
                  class="py-2"
                >
                  <div class="d-flex align-center" style="gap: 16px">
                    <img
                      style="width: 16px; height: 16px"
                      :src="flagMap[sub.country]"
                    />
                    <!-- <FlagCards :items="[sub.country]" /> -->
                    <span class="body-regular-small neutral-20-dark--text">
                      {{ sub.label }}
                    </span>
                  </div>
                  <base-btn
                    type="tertiary"
                    size="small"
                    @click="handleOpenReadyModal(sub)"
                  >
                    {{ $i18next.t('message.ai.dubbings.generate') }}
                  </base-btn>
                </v-col>
                <v-col
                  class="py-2"
                  cols="12"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="d-flex align-center" style="gap: 16px">
                    <v-icon
                      style="font-size: 16px"
                      class="neutral-40-light--text"
                    >
                      panda-globe
                    </v-icon>
                    <span class="body-regular-small neutral-20-dark--text">{{
                      $i18next.t('message.ai.dubbings.moreLanguages')
                    }}</span>
                  </div>
                  <base-btn
                    type="tertiary"
                    size="small"
                    @click="handleOpenReadyModal"
                  >
                    {{ $i18next.t('message.ai.dubbings.generate') }}
                  </base-btn>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-2">
                <v-col cols="12">
                  <base-btn
                    type="secondary"
                    size="small"
                    @click="handleOpenReadyModal"
                  >
                    <v-icon>mdi-plus</v-icon>
                    {{ $i18next.t('message.ai.subtitles.generateSubtitle') }}
                  </base-btn>
                </v-col>
              </v-row>
            </template>
          </template>
        </v-card>
      </portal>

      <!-- settings::colors -->
      <portal to="colors-tab">
        <div class="d-flex flex-column">
          <div class="my-2">
            <h3 class="body-bold-base neutral-20-dark--text">
              {{ $t('message.pages.video.appearance') }}
            </h3>
            <v-row no-gutters>
              <v-col
                cols="12"
                class="d-flex align-center justify-space-between my-2 py-2 menu__color"
              >
                <div class="d-flex-inline colorTitle">
                  {{ $t('message.playerPage.subtitleFontColor') }}
                </div>
                <div>
                  <v-menu
                    v-model="colors.menuFg"
                    :close-on-content-click="false"
                    offset-x
                    nudge-bottom="105"
                    nudge-left="16"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :color="colors.foreground"
                        :style="setSubtitlesFontColor"
                        class="rounded-pill border-slate"
                        icon
                      >
                        <span class="describeHexa">{{
                          colors.foreground
                        }}</span></v-btn
                      >
                    </template>
                    <v-color-picker
                      v-model="colors.foreground"
                      :maxlength="7"
                      mode="hexa"
                      hide-mode-switch
                      flat
                      @input="setCaptionPreview"
                    />
                  </v-menu>
                </div>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center justify-space-between my-2 py-2 menu__color"
              >
                <div class="d-flex-inline colorTitle">
                  {{ $t('message.playerPage.subtitleBackgroundColor') }}
                </div>
                <div>
                  <v-menu
                    v-model="colors.menuBg"
                    :close-on-content-click="false"
                    offset-x
                    nudge-bottom="105"
                    nudge-left="16"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :color="colors.background"
                        :style="setSubtitlesBgColor"
                        icon
                        class="rounded-pill border-slate"
                      >
                        <span class="describeHexa">{{
                          colors.background
                        }}</span></v-btn
                      >
                    </template>
                    <v-color-picker
                      v-model="colors.background"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      :maxlength="7"
                      @input="setCaptionPreview"
                    />
                  </v-menu>
                </div>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center justify-space-between my-2 py-2 menu__color"
              >
                <div class="colorTitle">
                  {{ $t('message.playerPage.subtitleFontSize') }}
                </div>
                <v-col cols="6" class="pa-0">
                  <v-select
                    :messages="addSubtitleErrorMsg"
                    :error="errors.addSubtitle"
                    :disabled="loadingPublish"
                    v-model="newSubtitle.fontSize"
                    hide-details
                    :items="fontSizes"
                    item-text="label"
                    :menu-props="{ top: false, offsetY: true }"
                    outlined
                    dense
                    @change="setCaptionPreview"
                    class="w-50"
                  ></v-select>
                </v-col>
              </v-col>
            </v-row>
          </div>
        </div>
      </portal>

      <!-- settings::settings -->
      <portal to="settings-tab">
        <h3 class="body-bold-base neutral-20-dark--text my-2">
          {{ $t('message.settings') }}
        </h3>
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          class="menu__color"
        >
          <div style="display: grid">
            <span
              class="body-regular-small neutral-20-dark--text"
              v-text="
                $i18next.t(
                  'message.pages.video.controlsPage.startWithSubtitleActive'
                )
              "
            ></span>
            <span class="body-regular-smaller neutral-40-light--text">{{
              $i18next.t(
                'message.pages.video.controlsPage.startWithSubtitleActiveSwitch'
              )
            }}</span>
          </div>
          <v-switch
            v-model="startsWithSubtitle"
            class="ma-0 pa-0 mr-1"
            hide-details
          />
        </v-row>
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          class="menu__color mt-3"
        >
          <v-col cols="8">
            <div style="display: grid">
              <span class="body-regular-small neutral-20-dark--text">{{
                $t('message.pages.videoPage.details.defaultCaption')
              }}</span>
              <span class="body-regular-smaller neutral-40-light--text">{{
                $t('message.ai.subtitles.describeTitle')
              }}</span>
            </div>
          </v-col>
          <base-btn
            v-if="!allSubtitles.length"
            type="tertiary"
            size="small"
            @click="handleTriggerSubtitleSelect"
            >{{ $t('message.actions.add') }}</base-btn
          >

          <v-select
            v-else
            placeholder="Selecione"
            :items="allSubtitlesTranslate"
            outlined
            :value="selectedItem"
            :messages="messageNotSelectedSub"
            :error="notSelectedDefaultSubtitle"
            @click="checkDefaultSubSelected"
            item-text="label"
            item-value="srclang"
            @change="handleUpdateDefaultSubtitle($event, true)"
            style="width: 30px"
          >
            <template #prepend-inner>
              <img class="mt-1 mr-2" :src="currentIcon" />
            </template>
          </v-select>
        </v-row>

        <v-divider class="my-8"></v-divider>
        <h3 class="body-bold-base neutral-20-dark--text my-2">
          {{ $i18next.t('message.ai.subtitles.smartSearchTitle') }}
        </h3>
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          class="menu__color"
        >
          <div style="display: grid">
            <span class="body-regular-small neutral-20-dark--text">{{
              $t('message.pages.video.controlsPage.smartSearch')
            }}</span>

            <span class="body-regular-smaller neutral-40-light--text">{{
              $t('message.pages.video.controlsPage.smartSearchSubtitle')
            }}</span>
            <div @click="handleKnowMoreSmartSearch">
              <a target="_blank" type="secondary" class="body-bold-smaller">
                {{ $t('message.knowMore') }}
                <v-icon size="12">mdi-open-in-new</v-icon>
              </a>
            </div>
          </div>
          <v-tooltip bottom :disabled="allSubtitles.length">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-switch
                  :disabled="!allSubtitles.length"
                  v-model="toggleSearchInsideVideo"
                  class="ma-0 pa-0 mr-1"
                  hide-details
                  @click="handleSwitchChange"
                />
              </div>
            </template>
            <span>{{
              $i18next.t('message.ai.subtitles.smartSearchDisableTooltip')
            }}</span>
          </v-tooltip>
        </v-row>
      </portal>

      <portal to="actions-footer">
        <div class="d-flex flex-row actions-row">
          <v-spacer></v-spacer>
          <v-tooltip max-width="184px" :disabled="!withoutChanges" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="pl-2" v-bind="attrs" v-on="on">
                <base-btn
                  @click="handleUndoChanges"
                  :disabled="withoutChanges"
                  type="tertiary"
                >
                  {{ $t('message.actions.cancel') }}
                </base-btn>
              </div>
            </template>
            <span>{{ $t('message.noChanges') }}</span>
          </v-tooltip>
          <v-tooltip max-width="184px" :disabled="!withoutChanges" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="pl-2" v-bind="attrs" v-on="on">
                <base-btn
                  @click="changePlayer"
                  :disabled="withoutChanges"
                  :loading="loadingChanges"
                >
                  {{ $t('message.actions.publish') }}
                </base-btn>
              </div>
            </template>
            <span>{{ $t('message.noChanges') }}</span>
          </v-tooltip>
        </div>
      </portal>
    </div>
    <v-row no-gutters class="px-2 subtitle-container"> </v-row>

    <v-row v-if="!isLoading" no-gutters justify="end">
      <v-col cols="6">
        <v-card
          height="25"
          class="d-flex flex-row justify-end align-center"
          flat
        >
          <span
            class="red--text caption align-text justify-end"
            v-if="errors.failedToUpdateVideo"
          >
            <v-icon color="red" size="16" class="pb-1">
              mdi-alert-circle
            </v-icon>
            {{ $t('message.errors.networkError') }} {{ networkErrorMsg }}
          </span>
        </v-card>
      </v-col>
    </v-row>
    <RemoveSubtitleModal
      @confirmDelete="handleDeleteSubtitle"
      :isLoading="loadings.onSubtitleDelete"
    />
    <SubtitleContentModal />
    <AiDeleteModal
      :title="$i18next.t('message.ai.subtitles.deleteModal.title')"
      modalKey="Subtitle"
      :description="$i18next.t('message.ai.subtitles.deleteModal.description')"
      :subtitle="subtitleToBeRemoved.label"
      @confirm="
        $root.$emit('closeAiDeleteModalSubtitle'),
          $root.$emit('openAiDeleteConfirmModalSubtitle')
      "
    />
    <AiConfirmDeleteModal
      :title="$i18next.t('message.ai.subtitles.deleteModal.title')"
      :onConfirmLogin="handleDeleteSubtitle"
      modalKey="Subtitle"
    />
    <UnsavedChangesModal></UnsavedChangesModal>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import AiDeleteModal from '@/components/AddSubtitleModal/AiDeleteModal.vue'
import AiConfirmDeleteModal from '@/components/AddSubtitleModal/AiConfirmDeleteModal.vue'
import RemoveSubtitleModal from '@/components/RemoveSubtitleModal.vue'
import SubtitleContentModal from '@/components/AddSubtitleModal/SubtitleContentModal.vue'
import PlayerTabsSubtitle from './PlayerTabsSubtitle.vue'
import _ from 'lodash'
import i18n from '@/translations/lang'
import videosApi from '@/services/videosApi'
import aiworkflowApi from '@/services/aiworkflowApi'
// import FlagCards from '@/components/FlagCards.vue'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'
import linkHelper from '@/utils/linkHelper.mixin.js'
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import globeIcon from '@/assets/pandaIcons/globe.svg'
import langCodesMixin from '@/utils/langCodes.mixin.js'
export default {
  name: 'VideoPlayerSubtitles',
  mixins: [aiWorkflowMixin, linkHelper, langCodesMixin],
  components: {
    RemoveSubtitleModal,
    SubtitleContentModal,
    PlayerTabsSubtitle,
    AiDeleteModal,
    AiConfirmDeleteModal,
    UnsavedChangesModal,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    updateKey: 0,
    loadAiSubtitlesTimeout: null,
    openConfirmRemove: false,
    subtitleToBeRemoved: {},
    updateDefaultSubtitleData: {},
    colorsUpdate: false,
    hasChanged: false,
    globeIcon,
    notSelectedDefaultSubtitle: false,
    radioGroup: 1,
    subtitles: [],
    newSubtitle: {
      label: '',
      srclang: '',
      file: null,
      fontSize: '',
    },
    langsBeingRemoved: [],
    errors: {
      addSubtitle: false,
      wrongSubtitleFile: false,
      deleteSubtitle: false,
      subtitleRemove: false,
      unknownErrorsCode: '',
      unknownErrorsMsg: '',
    },
    loadings: {
      subtitle: false,
      onSubtitleDelete: false,
      subtitleDefault: false,
      fetching: true,
    },
    isLoading: false,
    defaultSubtitle: false,
    messageNotSelectedSub: '',
    colors: {
      menuFg: false,
      menuBg: false,
      foreground: 'FFFFFFFF',
      background: '000000FF',
    },
    flagMap: {
      br: require('@/assets/brazil.svg'),
      us: require('@/assets/english.svg'),
      it: require('@/assets/italy.svg'),
      es: require('@/assets/spanish.svg'),
      fr: require('@/assets/france.svg'),
      de: require('@/assets/germany.svg'),
      ru: require('@/assets/russia.svg'),
      nl: require('@/assets/netherlands.svg'),
      pl: require('@/assets/poland.svg'),
      in: require('@/assets/india.svg'),
      tr: require('@/assets/turkey.svg'),
      id: require('@/assets/indonesia.svg'),
      bg: require('@/assets/bulgaria.svg'),
      ro: require('@/assets/romania.svg'),
      cz: require('@/assets/czech-republic.svg'),
      gr: require('@/assets/greece.svg'),
      fi: require('@/assets/finland.svg'),
      hr: require('@/assets/croatia.svg'),
      sk: require('@/assets/slovakia.svg'),
      jp: require('@/assets/japan.svg'),
      ua: require('@/assets/ukraine.svg'),
      kr: require('@/assets/south-korea.svg'),
      se: require('@/assets/sweden.svg'),
      no: require('@/assets/norway.svg'),
      rs: require('@/assets/serbia.svg'),
      hu: require('@/assets/hungary.svg'),
      sa: require('@/assets/saudi-arabia.svg'),
      th: require('@/assets/thailand.svg'),
      vn: require('@/assets/vietnam.svg'),
      cn: require('@/assets/china.svg'),
      ke: require('@/assets/kenya.svg'),
      my: require('@/assets/malaysia.svg'),
      ur: require('@/assets/pakistan.svg'),
      pk: require('@/assets/pakistan.svg'),
    },
    initialConfig: {},
    defaultSubtitleObject: {},
    newSubtitleInitialConfig: {},
    loadingPublish: false,
    profileId: null,
    loopCheck: false,
    tabHidden: false,
    toggleSearchInsideVideo: false,
    toggleTimeout: null,
    startsWithSubtitle: false,
    startsWithSubtitleInitial: false,
    toggleSearchInsideVideoInitial: false,
    defaultSubtitleInitial: false,
    loadingChanges: false,
    fontSizes: [
      {
        label: i18n.t('message.pages.videoEditModal.fontSizes.small'),
        value: 'small',
      },
      {
        label: i18n.t('message.pages.videoEditModal.fontSizes.normal'),
        value: 'normal',
      },
      {
        label: i18n.t('message.pages.videoEditModal.fontSizes.large'),
        value: 'large',
      },
    ],
  }),
  beforeDestroy() {
    this.$root.$off('addAiWorkflowSubtitle')
    this.UPDATE_GENERATING_SUBTITLE_DATA([])
    clearTimeout(this.loadAiSubtitlesTimeout)
    this.loopCheck = false
    window.removeEventListener('message', this.handleMessageEvent)
  },
  async mounted() {
    this.$emit('showFooter', true)
    this.loadings.fetching = true
    this.$root.$on('changeLanguage', () => {
      this.fontSizes = [
        {
          label: i18n.t('message.pages.videoEditModal.fontSizes.small'),
          value: 'small',
        },
        {
          label: i18n.t('message.pages.videoEditModal.fontSizes.normal'),
          value: 'normal',
        },
        {
          label: i18n.t('message.pages.videoEditModal.fontSizes.large'),
          value: 'large',
        },
      ]
    })
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.subtitles = this.$store.state.video.video.config?.subtitles
    this.profileId = this.$store.state.video.video.config?.profile
    this.startsWithSubtitle =
      this.$store.state.video.profile?.general?.startsWithSubtitle || false
    this.toggleSearchInsideVideo = this.$store.state.video.smartSearch
    this.newSubtitle.fontSize = this.getFontSizeObject(
      this.$store.state.video.profile?.general?.captionsFontSize
    )
    this.colors.foreground = this.profile.colors.captionsColor + 'FF'
    this.colors.background = this.profile.colors.captionsBackgroundColor + 'FF'
    this.hasEdit.push(this.withoutChanges)

    if (!this.subtitles) {
      this.subtitles = []
    }

    this.defaultSubtitle = this.$store.state.video.video.config?.defaultSubtitle
    this.$nextTick(() => {
      this.setColors()
      this.newSubtitleInitialConfig = _.cloneDeep(this.newSubtitle)
    })

    const _this = this
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        this.tabHidden = false
        if (this.loopCheck) {
          this.loadAiSubtitlesTimeout = setTimeout(
            () => _this.handleFetchAiSubtitles(true),
            10 * 1000
          )
        }
      } else {
        this.tabHidden = true
        clearTimeout(this.loadAiSubtitlesTimeout)
      }
    })

    this.handleFetchAiSubtitles()

    this.$root.$on('addAiWorkflowSubtitle', this.handleFetchAiSubtitles)
    this.radioGroup = this.getDefaultSubtitleIndex()
    this.setEventListener()
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
      window.removeEventListener('message', this.handleMessageEvent)
    })
    this.startsWithSubtitleInitial = this.startsWithSubtitle
    this.toggleSearchInsideVideoInitial = this.toggleSearchInsideVideo
    this.defaultSubtitleInitial = this.defaultSubtitle
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile: (state) => state.video.profile,
      profile_id: (state) => state.video.profile_id,
      defaultSubtitleState: (state) => state.video.video.config.defaultSubtitle,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    setSubtitlesFontColor() {
      return {
        backgroundColor: this.colors.foreground,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: this.colors.menuFg ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setSubtitlesBgColor() {
      console.log(this.colors.background)
      return {
        backgroundColor: this.colors.background,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: this.colors.menuBg ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    allSubtitles() {
      const subtitles = [...this.subtitles, ...this.subtitleGeneratingData]
      return subtitles
    },
    currentIcon() {
      const country = this.getCountryCodeBySrcLang(this.defaultSubtitle)
      const selectedItem = this.flagMap[country]
      return selectedItem ? selectedItem : require('@/assets/brazil.svg')
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    selectedItem() {
      const subtitles = [...this.subtitles, ...this.subtitleGeneratingData]
      const formattedSubtitleLang =
        this.defaultSubtitle === 'pt' ? 'pt-BR' : this.defaultSubtitle
      const selectedItem = subtitles.find(
        (sub) => sub.srclang === formattedSubtitleLang
      )
      return selectedItem
    },
    allSubtitlesTranslate() {
      const subtitles = [...this.subtitles]
      if (!subtitles.length) return []
      subtitles.forEach((sub) => {
        sub.label = this.getLangLabelBySrclang(
          sub.srclang || (sub.metadata || {}).to_lang
        )
      })

      const subtitlesFiltered = subtitles.filter((sub) => !sub.hidden)
      return subtitlesFiltered
    },
    formValidationSubtitle() {
      return !!this.newSubtitle.label && this.newSubtitle.file instanceof File
    },
    unusedLangCodes() {
      return this.langCodes.filter((lang) => {
        return !this.subtitles.find((sub) => sub.srclang === lang.srclang)
      })
    },
    pixelFontSizes() {
      return {
        small: 14,
        normal: 20,
        large: 36,
      }
    },
    addSubtitleFileErrorMsg() {
      if (this.errors.wrongSubtitleFile) {
        return i18n.t('message.pages.videoEditModal.errors.wrongSubtitleFile')
      }
      return ''
    },
    addSubtitleErrorMsg() {
      if (this.errors.addSubtitle) {
        return i18n.t('message.pages.videoEditModal.errors.defaultSubtitleErr')
      }
      return ''
    },
    hasSubtitles() {
      return this.subtitles.length > 0
    },
    fgBtnStyle() {
      return {
        backgroundColor: this.colors.foreground,
      }
    },
    bgBtnStyle() {
      return {
        backgroundColor: this.colors.background,
      }
    },
    withoutChanges() {
      return (
        _.isEqual(this.colors, this.initialConfig) &&
        _.isEqual(this.newSubtitle, this.newSubtitleInitialConfig) &&
        _.isEqual(this.startsWithSubtitle, this.startsWithSubtitleInitial) &&
        _.isEqual(
          this.toggleSearchInsideVideoInitial,
          this.toggleSearchInsideVideo
        ) &&
        _.isEqual(this.defaultSubtitle, this.defaultSubtitleInitial)
      )
    },
  },
  watch: {
    colors: {
      async handler(data) {
        if (!data.menuBg && !data.menuFg && this.colorsUpdate) {
          // await this.handleUpdate()
          this.colorsUpdate = false
        }
      },
      deep: true,
      immediate: false,
    },
    'newSubtitle.fontSize': {
      async handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (
            newValue &&
            newValue ===
              this.getFontSizeObject(
                this.$store.state.video.profile?.general?.captionsFontSize
              ) &&
            newValue !== oldValue
          ) {
            // await this.handleUpdate()
          }
        }
      },
    },
    'colors.foreground': {
      async handler(newForeground, oldForeground) {
        if (newForeground && oldForeground) {
          if (
            newForeground === this.profile.colors.captionsColor &&
            newForeground !== oldForeground
          ) {
            this.checkColorChange(newForeground, oldForeground)
          }
        }
      },
      deep: true,
      immediate: false,
    },
    'colors.background': {
      async handler(newBackground, oldBackground) {
        if (newBackground && oldBackground) {
          if (
            newBackground === this.profile.colors.captionsBackgroundColor &&
            newBackground !== oldBackground
          ) {
            this.checkColorChange(newBackground, oldBackground)
          }
        }
      },
      deep: true,
      immediate: false,
    },
    defaultSubtitleState: {
      async handler(data) {
        this.radioGroup = this.getDefaultSubtitleIndex()
        if (data !== this.defaultSubtitle) {
          this.defaultSubtitle = data
          await this.handleUpdateDefaultSubtitle(data)
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    ...mapActions('video', ['updateProfile']),
    ...mapMutations('video', ['UPDATE_SMART_SEARCH']),
    handleSwitchChange() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.handleSearchInsideVideo()
      }, 2000)
    },
    checkDefaultSubSelected() {
      if (this.defaultSubtitle) {
        this.notSelectedDefaultSubtitle = false
        this.messageNotSelectedSub = ''
        return
      }
      this.messageNotSelectedSub = this.$i18next.t(
        'message.ai.subtitles.messageNotSelectedSub'
      )
      this.notSelectedDefaultSubtitle = true
    },
    checkAllSubtitlesAreOk() {
      const haveSomeError = this.allSubtitles.some((subtitle) => {
        if (subtitle.metadata?.language_not_supported) return true
        return false
      })
      return haveSomeError
    },
    async handleSetSubtitleAsHidden(sub) {
      const hidden = !sub?.hidden
      this.subtitles.map((item) => {
        if (_.isEqual(item, sub)) {
          item.hidden = hidden
        }
        return item
      })
      this.updateKey += 1
      const { data } = await videosApi.updateVideoSubtitleContent(
        this.videoId,
        {
          hidden,
          srclang: sub.srclang,
        }
      )
      this.subtitles = data.response
      console.log(data.response)
      this.UPDATE_VIDEO_SUBTITLES(data.response)
      this.UPDATE_VIDEO({ ...this.video })
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleSearchInsideVideo() {
      let profileId = this.$store.state.video.video.config?.profile
      if (!profileId) {
        await this.createVideoProfile()
        profileId = this.profileId
      }
      try {
        await this.updateProfile([
          profileId,
          {
            general: { smartSearch: this.toggleSearchInsideVideo },
          },
        ])
        this.UPDATE_SMART_SEARCH(this.toggleSearchInsideVideo)
      } catch (e) {
        console.error(e)
      }
    },
    handleKnowMoreSmartSearch() {
      const link = this.getSmartSearchLink()
      window.open(link, '_blank')
    },
    handleKnowMore() {
      const link = this.getAiSubtitlesLink()
      window.open(link, '_blank')
    },
    async checkColorChange(newOne, oldOne) {
      let somethingHasChanged = false
      if (newOne) {
        this.setCaptionsColor(newOne)
        if (oldOne && newOne !== oldOne) {
          somethingHasChanged = true
        }
      }
      if (somethingHasChanged) this.colorsUpdate = true
    },
    getBlockingItem(subtitle) {
      const blockItem = this.allSubtitles.filter((item) => {
        if (item.metadata?.dependent_works) {
          return item.metadata.dependent_works.includes(subtitle.id)
        } else if (item.metadata?.dependent_work) {
          return subtitle.id === item.metadata.dependent_work
        }

        return false
      })
      if (!blockItem.length) return 'null'
      return this.getLangCodeBySrcLang(
        blockItem[0].metadata.to_lang ?? blockItem[0].metadata.from_lang
      )?.label
    },
    async handleOpenSubtitleContent({ srclang }) {
      this.$root.$emit('openSubtitleContent', srclang)
    },
    handleConfirmSubtitleDelete(subtitle) {
      this.subtitleToBeRemoved = subtitle
      this.$root.$emit('openAiDeleteModalSubtitle')
    },
    async handleDeleteSubtitle() {
      const subtitle = this.subtitleToBeRemoved
      this.loadings.onSubtitleDelete = true

      try {
        if (subtitle?.status) {
          const langsBeingRemovedlastIndex = this.langsBeingRemoved.length - 1
          this.langsBeingRemoved.push(
            subtitle.metadata.to_lang ?? subtitle.metadata.from_lang
          )
          await aiworkflowApi.deleteAiWorkflow(subtitle.id)

          const newSubtitleGeneratingData = this.subtitleGeneratingData.filter(
            (item) =>
              (item.metadata?.to_lang ?? item.metadata?.from_lang) !=
              (subtitle.metadata?.to_lang ?? subtitle.metadata?.from_lang)
          )

          this.UPDATE_GENERATING_SUBTITLE_DATA(newSubtitleGeneratingData)

          this.langsBeingRemoved.splice(langsBeingRemovedlastIndex, 1)
        } else {
          await this.handleRemoveSubtitle(subtitle.srclang)
        }
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.ai.subtitles.removeSubtitle'),
          type: 'success',
        })
        this.loadings.onSubtitleDelete = false
        this.$root.$emit('closeAiDeleteConfirmModalSubtitle')
        this.$root.$emit('updateEmbedPreviewChange')
      } catch (e) {
        if (e?.response?.data?.errCode) {
          this.errors.unknownErrorsCode = e.response.data.errCode
          this.errors.unknownErrorsMsg = e.response.data.errMsg
        } else {
          this.errors.unknownErrorsMsg = i18n.t(
            'message.errors.unexpectedError'
          )
        }
        this.$root.$emit('closeAiDeleteConfirmModalSubtitle')
        this.errors.subtitleRemove = true
        this.loadings.onSubtitleDelete = false
      }
    },
    async handleFetchAiSubtitles(isLoopingCheck) {
      if (this.tabHidden && this.loopCheck) return
      if (isLoopingCheck) {
        this.loopCheck = isLoopingCheck
      }

      const { data } = await aiworkflowApi.getAiWorkflow(this.videoId)
      let subtitlesBeingGenerated = data.filter((item) => {
        if (
          item.status !== 'FINISHED' &&
          (item.type === 'TRANSCRIPTION' || item.type === 'TRANSLATE')
        ) {
          return true
        }
        return false
      })
      const onlyInA = this.subtitleGeneratingData.filter(
        (leftValue) =>
          !subtitlesBeingGenerated.some(
            (rightValue) => leftValue.id === rightValue.id
          )
      )

      const _this = this
      if (onlyInA.length) {
        onlyInA.map((item) =>
          _this.subtitles.push({
            srclang: item.metadata?.to_lang ?? item.metadata.from_lang,
            label: this.getLangLabelBySrclang(
              item.metadata?.to_lang ?? item.metadata.from_lang
            ),
          })
        )
        window.db.videos.update(this.videoId, {
          subtitles: this.subtitles.map((item) => item.srclang),
        })
        this.handleUpdateCaptionsOnPlayer()
      }

      this.UPDATE_GENERATING_SUBTITLE_DATA(subtitlesBeingGenerated)
      const beingProcessedSubtitle = this.subtitleGeneratingData.filter(
        (item) => item.status === 'QUEUE' || item.status === 'RUNNING'
      )

      if (!isLoopingCheck) {
        this.loadings.fetching = false
      }

      if (beingProcessedSubtitle.length > 0) {
        _this.loadAiSubtitlesTimeout = setTimeout(
          () => _this.handleFetchAiSubtitles(true),
          10 * 1000
        )
      } else {
        this.loopCheck = false
        this.updateState()
      }
    },
    handleUpdateCaptionsOnPlayer() {
      const captionsIdx = this.profile.controls.indexOf('captions')
      if (captionsIdx >= 0) {
        this.profile.controls.splice(captionsIdx, 1)
      }
      this.profile.controls.splice(captionsIdx, 0, 'captions')
    },
    handleOpenReadyModal(selectedLang) {
      this.$root.$emit('openSubtitleModal', {
        videoId: this.videoId,
        initialState: true,
        selectedLang,
      })
    },
    getDefaultSubtitleIndex() {
      let defaultSubtitleIndex = null
      this.subtitles.forEach((subtitle, index) => {
        if (this.checkIfSubtitleIsDefault(subtitle)) {
          defaultSubtitleIndex = index
        }
      })
      return defaultSubtitleIndex
    },
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_STATUS_ERROR',
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_GENERATING_SUBTITLE_DATA',
      'UPDATE_VIDEO_SUBTITLES',
    ]),
    ...mapActions('dashboard', [
      'setCaptionsColor',
      'setCaptionsBackgroundColor',
    ]),
    ...mapActions('video', [
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleSetRadioGroup(e, i) {
      e.preventDefault()
      this.radioGroup = i
    },
    handleDownloadSubtitle({ srclang }) {
      const downloadURL = this.getSubtitleDownloadLink(srclang)
      window, open(downloadURL)
    },
    getSubtitleDownloadLink(srclang) {
      const isStaging = process.env.VUE_APP_ENV !== 'production'
      const downloadURL = `https://subtitles${
        isStaging ? '-staging' : ''
      }.tv.pandavideo.com.br/${this.video.pullzone_name}/${
        this.video.video_external_id
      }/${srclang}.vtt`
      return downloadURL
    },
    handleTriggerSubtitleSelect() {
      this.$root.$emit('openSubtitleModal', { videoId: this.videoId })
    },
    checkIfSubtitleIsDefault(subtitle) {
      return this.defaultSubtitle === subtitle.srclang
    },
    getFontSizeObject(size) {
      if (!size) return 'normal'
      size = Number(size)
      if (size < 20) {
        return this.fontSizes[0].value
      } else if (size === 20 || !size) {
        return this.fontSizes[1].value
      }
      return this.fontSizes[2].value
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$i18next.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    async handleUpdateDefaultSubtitle(subtitle, isString) {
      this.hasChanged = true
      if (isString) {
        const selectedSub = subtitle
        subtitle = {}
        subtitle.srclang = selectedSub
      }
      this.loadings.subtitleDefault = true
      const formattedSubtitleLang =
        subtitle.srclang === 'pt-BR' ? 'pt' : subtitle.srclang
      this.updateDefaultSubtitleData = {
        video_id: this.videoId,
        defaultSubtitle: formattedSubtitleLang,
      }
      if (this.video.config.defaultSubtitle === subtitle.srclang) {
        this.updateDefaultSubtitleData.defaultSubtitle = false
        this.video.config.defaultSubtitle = false
        this.defaultSubtitle = false
      } else {
        this.video.config.defaultSubtitle = subtitle.srclang
        this.defaultSubtitle = subtitle.srclang
      }

      this.UPDATE_VIDEO(this.video)
      this.checkDefaultSubSelected()
      try {
        // await videosApi.updateDefaultSubtitle(this.updateDefaultSubtitleData)
      } catch (e) {
        console.error(e)
      }
      this.loadings.subtitleDefault = false
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleRemoveSubtitle(srclang) {
      this.clearErrors()
      this.clearErrorMsg()
      const langsBeingRemovedlastIndex = this.langsBeingRemoved.length - 1
      this.langsBeingRemoved.push(srclang)
      await videosApi.deleteSubtitleFromVideo(this.videoId, srclang)
      this.subtitles = this.subtitles.filter(
        (subtitle) => subtitle.srclang != srclang
      )
      this.langsBeingRemoved.splice(langsBeingRemovedlastIndex, 1)
      if (srclang === this.defaultSubtitle) {
        if (this.subtitles.length) {
          await this.handleUpdateDefaultSubtitle(this.subtitles[0])
        } else {
          this.video.config.defaultSubtitle = false
          this.updateDefaultSubtitleData = {
            video_id: this.videoId,
            defaultSubtitle: false,
          }
          await videosApi.updateDefaultSubtitle(this.updateDefaultSubtitleData)
        }
      }
      this.handleUpdateCaptionsOnPlayer()
      this.changeState()
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    clearErrorMsg() {
      Object.keys(this.errors.unknownErrorsMsg).forEach(
        (e) => (this.errors.unknownErrorsMsg[e] = '')
      )
    },
    onScroll() {
      this.scrollInvoked++
    },
    changeState() {
      this.video.config.subtitles = this.subtitles
      this.UPDATE_VIDEO(this.video)
    },
    async updateState() {
      try {
        const data = await videosApi.getVideoConfig(
          this.video.pullzone_name,
          this.video.video_external_id
        )
        if (data.subtitles && data.subtitles.length > 0) {
          this.subtitles = data.subtitles
          this.UPDATE_VIDEO_SUBTITLES(data.subtitles || [])
        }
      } catch (e) {
        console.error(e)
      }
    },
    setColors() {
      const { captionsColor, captionsBackgroundColor } = this.profile.colors

      this.colors.foreground = captionsColor + 'FF'
      this.colors.background = captionsBackgroundColor + 'FF'

      this.colors.foreground = this.addOpacity(this.colors.foreground)
      this.colors.background = this.addOpacity(this.colors.background)

      this.initialConfig = _.cloneDeep(this.colors)

      // this.changePlayer()
    },

    async changePlayer() {
      this.loadingChanges = true
      const iframe = document.getElementById('panda-player').contentWindow
      const foreground = this.colors.foreground
      const background = this.colors.background
      const fontSize = this.pixelFontSizes[this.newSubtitle.fontSize]

      this.profile.colors.captionsColor = this.addOpacity(foreground)
      this.profile.colors.captionsBackgroundColor = this.addOpacity(background)
      this.profile.general.captionsFontSize = fontSize
      this.UPDATE_STATUS_ERROR(false)
      this.UPDATE_VIDEO_PROFILE(this.profile)

      iframe.postMessage(
        {
          type: 'colors',
          parameter: {
            colors: {
              captionsColor: this.addOpacity(foreground),
              captionsBackgroundColor: this.addOpacity(background),
            },
          },
        },
        '*'
      )
      this.handleUpdate()
    },
    async createVideoProfile() {
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
    },
    addOpacity(color, opacity = 'B3') {
      return `${color}${opacity}`.slice(0, 9)
    },
    handleUndoChanges() {
      this.colors = _.cloneDeep(this.initialConfig)
      this.newSubtitle = _.cloneDeep(this.newSubtitleInitialConfig)
      this.startsWithSubtitle = _.cloneDeep(this.startsWithSubtitleInitial)
      this.toggleSearchInsideVideo = _.cloneDeep(
        this.toggleSearchInsideVideoInitial
      )
      this.defaultSubtitle = _.cloneDeep(this.defaultSubtitleInitial)
      this.changePlayer()
      this.disableCaptionPreview()
      this.loadingChanges = false
    },
    async handleUpdate() {
      this.loadingPublish = true

      try {
        await this.createVideoProfile()
        await videosApi.updateDefaultSubtitle(this.updateDefaultSubtitleData)
        await this.updateProfile([
          this.profileId,
          {
            colors: {
              ...this.profile.colors,
              captionsColor: this.colors.foreground,
              captionsBackgroundColor: this.colors.background,
            },
            general: {
              ...this.profile.general,
              captionsFontSize: this.pixelFontSizes[this.newSubtitle.fontSize],
              startsWithSubtitle: this.startsWithSubtitle,
            },
          },
        ])

        if (this.internalError) return

        this.handleSnackbar(this.$t('message.pages.video.changesSaved'))
        this.initialConfig = _.cloneDeep(this.colors)
        this.newSubtitleInitialConfig = _.cloneDeep(this.newSubtitle)
        this.defaultSubtitleInitial = _.cloneDeep(this.defaultSubtitle)
        this.startsWithSubtitleInitial = _.cloneDeep(this.startsWithSubtitle)
        this.toggleSearchInsideVideoInitial = _.cloneDeep(
          this.toggleSearchInsideVideo
        )

        this.loadingChanges = false
        this.hasChanged = false
        this.withoutChanges = false
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingPublish = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    translateLabel(label) {
      const LANGUAGE_KEYS = {
        Portuguese: 'message.pages.videoEditModal.languages.portuguese',
        Spanish: 'message.pages.videoEditModal.languages.spanish',
        English: 'message.pages.videoEditModal.languages.english',
        French: 'message.pages.videoEditModal.languages.french',
        German: 'message.pages.videoEditModal.languages.german',
        Italian: 'message.pages.videoEditModal.languages.italian',
      }

      if (typeof label !== 'string') {
        return label
      }

      for (const [language, i18nKey] of Object.entries(LANGUAGE_KEYS)) {
        if (label.includes(language)) {
          return this.$i18next.t(i18nKey)
        }
      }

      return label
    },
    lowerCase(item) {
      if (item) return item.toLowerCase()
      if (!item) return 'noLabel'
    },
    enableCaptionPreview() {
      this.handlePlayerCaptionPreview('handle')
      const backgroundColor = this.colors.background
      const textColor = this.colors.foreground
      const fontSize = this.pixelFontSizes[this.newSubtitle.fontSize]

      const iframe = document.getElementById('panda-player')
      iframe.contentWindow.postMessage(
        {
          type: 'enable_caption_preview',
          parameter: {
            backgroundColor: backgroundColor,
            textColor: textColor,
            fontSize: fontSize,
          },
        },
        '*'
      )
    },
    setCaptionPreview() {
      const backgroundColor = this.colors.background
      const textColor = this.colors.foreground
      const fontSize = this.pixelFontSizes[this.newSubtitle.fontSize] + 'px'
      const iframe = document.getElementById('panda-player')
      iframe.contentWindow.postMessage(
        {
          type: 'set_caption_preview',
          parameter: {
            backgroundColor: backgroundColor,
            textColor: textColor,
            fontSize: fontSize,
          },
        },
        '*'
      )
      this.enableCaptionPreview()
    },
    disableCaptionPreview() {
      const iframe = document.getElementById('panda-player')

      iframe.contentWindow.postMessage(
        {
          type: 'disable_caption_preview',
        },
        '*'
      )
      this.handlePlayerCaptionPreview('undo')
    },
    handlePlayerCaptionPreview(param) {
      const handle = param === 'handle'
      let functionToExecuteOnPlayer

      if (handle) {
        functionToExecuteOnPlayer = function captionPreviewPreSettings() {
          /* eslint-disable no-undef */
          const isPlaying = window.player.playing
          const isCaptionsActive = window.player.captions.active

          function handleCaptionText() {
            const captionElement = document.querySelector(
              '.plyr__caption:not(#caption-preview)'
            )
            if (!captionElement) return
            const innerText = captionElement.innerText
            if (innerText) captionElement.innerText = ''
          }

          if (isPlaying) player.pause()
          if (isCaptionsActive) handleCaptionText()

          const bigPlayButton = document.querySelector(
            '[data-plyr="play"].plyr__control.plyr__control--overlaid'
          )
          if (bigPlayButton) bigPlayButton.style.visibility = 'hidden'
          const plyr = document.querySelector('.plyr')
          setTimeout(() => {
            plyr.classList.add('plyr--hide-controls')
          }, 1000)
        }
      } else {
        functionToExecuteOnPlayer = function undoCaptionPreviewPreSettings() {
          /* eslint-disable no-undef */
          const bigPlayButton = document.querySelector(
            '[data-plyr="play"].plyr__control.plyr__control--overlaid'
          )
          if (bigPlayButton) bigPlayButton.style.visibility = ''
        }
      }

      const functionString = functionToExecuteOnPlayer.toString()
      const messageType = 'run_internal_methods'
      const message = {
        type: messageType,
        function: functionString,
        parameter: false,
      }
      const iframe = document.querySelector('iframe')
      iframe.contentWindow.postMessage(message, '*')
    },
    setEventListener() {
      this.handleMessageEvent = this.handleMessageEvent.bind(this)
      window.addEventListener('message', this.handleMessageEvent)
    },
    handleMessageEvent(event) {
      const eventMessage = event.data.message
      if (eventMessage === 'panda_canplay') {
        this.loadingChanges = false
        this.initialConfig = _.cloneDeep(this.colors)
        this.newSubtitleInitialConfig = _.cloneDeep(this.newSubtitle)
        window.removeEventListener('message', this.handleMessageEvent)
      }
    },
    beforeLeave() {
      if (!this.withoutChanges || this.notSelectedDefaultSubtitle) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.handleBack()
        window.removeEventListener('message', this.handleMessageEvent)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>

<style scoped lang="scss">
.margin-bot {
  @media (max-width: 84rem) {
    margin-bottom: 24px !important;
  }
}
.base-button.--subtitles {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 0 !important;
  width: 30px !important;
  height: 30px !important;
}
.bgFg-btn {
  border-radius: 4px;
  transition: border-radius 200ms ease-in-out;
  height: 100%;
  width: 100px;
  padding: 4px;
  border: 1px solid var(--v-neutral-lighten2);
  border-radius: 4px;

  div {
    border-radius: 2px;
    height: 100%;
    width: 100%;
    border: 1px solid var(--v-neutral-lighten3);
  }

  &--disabled {
    @extend .bgFg-btn;
    cursor: not-allowed;
    opacity: 0.7;
    filter: grayscale(0.3);
  }
}

::v-deep .subtitle-container * {
  font-family: 'Rubik', sans-serif !important;
}

::v-deep .subtitle {
  font-size: 18px;
}
.select__fontSize {
  max-width: 164px;
}
::v-deep .v-input__prepend-inner img {
  width: 16px;
}
.v-card__ai-empty-state {
  border-radius: 4px;
  border: 1px solid var(--v-neutral-lighten3);
}

.v-menu__content:has(.list__subtitle-actions) {
  box-shadow: none !important;
}

.icon-neutral-40-light {
  color: varFigma(neutral-40-light);
}
.menu__color {
  &:hover {
    background-color: varFigma(neutral-99);
  }
}
.border-slate {
  height: 16px !important;
  width: 17px !important;
  border: varFigma(neutral-30-base) 1px solid;
}
.describeHexa {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 10%;
  color: varFigma(neutral-40-light);
  margin-right: 130px;
  width: 100px;
  display: flex;
  justify-content: end;
}
.colorTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: varFigma(neutral-20-dark);
}
.describeImpact {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: varFigma(neutral-40-light);
}
::v-deep
  .v-select.error--text
  .v-input__control
  .v-input__slot
  .v-input__prepend-inner {
  display: none;
}
::v-deep .v-input__prepend-inner img {
  max-width: 16px;
}
::v-deep .list__subtitle-actions {
  padding: 0;
  border-radius: 4px;
  border: 1px solid #e3e3e8;
  .v-list-item {
    min-height: unset;
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
.hidden-sub {
  color: varFigma(neutral-70) !important;
}
</style>
